module.exports = __webpack_public_path__ + "static/media/UPS_TEMPLATE.8798f755.xlsx";